import React from "react";
import Filter from "./Filter";
import "../css/Popup.css";
import Resetpassword from "./Resetpassword";

const Popup = ({ show, onClose, children,title }) => {

  const disableRightClick = (e) => {
    e.preventDefault();
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block " tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.6)" }} onClick={onClose}  onContextMenu={disableRightClick}>
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()} s>
        <div className="modal-content w-100" >
          <div className="modal-header">
              <h4 className="modal-title">{title}</h4>
            {/* Title will be passed as part of children from Settingspage.js */}
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;